import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import jackpotService from "./jackpotService";

export const getJackpots = createAsyncThunk(
  "jackpot/get-jackpots",
  async (params, thunkAPI) => {
    try {
      return await jackpotService.getJackpots(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getJackpot = createAsyncThunk(
  "jackpot/get-jackpot",
  async (data, thunkAPI) => {
    try {
      return await jackpotService.getJackpot(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createJackpot = createAsyncThunk(
  "jackpot/create-jackpot",
  async (data, thunkAPI) => {
    try {
      return await jackpotService.createJackpot(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateJackpot = createAsyncThunk(
  "jackpot/update-jackpot",
  async (data, thunkAPI) => {
    try {
      return await jackpotService.updateJackpot(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteJackpot = createAsyncThunk(
  "jackpot/delete-jackpot",
  async (data, thunkAPI) => {
    try {
      return await jackpotService.deleteJackpot(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const refreshJackpot = createAsyncThunk(
  "jackpot/refresh-jackpot",
  async (data, thunkAPI) => {
    try {
      return await jackpotService.refreshJackpot(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateJackpotStatus = createAsyncThunk(
  "customer/update-jackpot-status",
  async (data, thunkAPI) => {
    try {
      return await jackpotService.updateJackpotStatus(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getJackpotEntries = createAsyncThunk(
  "jackpot/get-jackpot-entries",
  async (params, thunkAPI) => {
    try {
      return await jackpotService.getJackpotEntries(params);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getJackpotEntry = createAsyncThunk(
  "jackpot/get-jackpot-entry",
  async (data, thunkAPI) => {
    try {
      return await jackpotService.getJackpotEntry(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateJackpotEntry = createAsyncThunk(
  "jackpot/update-jackpot-entry",
  async (data, thunkAPI) => {
    try {
      return await jackpotService.updateJackpotEntry(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const approveJackpotEntry = createAsyncThunk(
  "jackpot/approve-jackpot-entry",
  async (data, thunkAPI) => {
    try {
      return await jackpotService.approvedJackpotEntry(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const rejectJackpotEntry = createAsyncThunk(
  "jackpot/reject-jackpot-entry",
  async (data, thunkAPI) => {
    try {
      return await jackpotService.rejectJackpotEntry(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const addToFeedJackpotEntry = createAsyncThunk(
  "jackpot/add-to-feed-jackpot-entry",
  async (data, thunkAPI) => {
    try {
      return await jackpotService.addToFeedJackpotEntry(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const removeFromFeedJackpotEntry = createAsyncThunk(
  "jackpot/remove-from-feed-jackpot-entry",
  async (data, thunkAPI) => {
    try {
      return await jackpotService.removeFromFeedJackpotEntry(data);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

const initialState = {
  jackpots: [],
  jackpotEntries: [],
  total: 0,
  jackpotEntryCount: 0,
  jackpot: {},
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
  updating: false,
  isUpdateSuccess: false,
  creating: false,
  isCreateSuccess: false,
  isUpdateStatusSuccess: false,
  jackpotEntry: {},
};
export const jackpotSlice = createSlice({
  name: "jackpot",
  initialState,
  reducers: {
    initJackpot: (state) => {
      state.isError = false;
      state.isLoading = false;
      state.isSuccess = false;
      state.message = "";
      state.updating = false;
      state.isUpdateSuccess = false;
      state.creating = false;
      state.isCreateSuccess = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getJackpots.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getJackpots.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.jackpots = action.payload.jackpots;
        state.total = action.payload.jackpotCount;
        state.isCreateSuccess = false;
        state.isUpdateSuccess = false;
      })
      .addCase(getJackpots.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(createJackpot.pending, (state, action) => {
        state.creating = true;
        state.isCreateSuccess = false;
      })
      .addCase(createJackpot.rejected, (state, action) => {
        state.isError = true;
        state.creating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(createJackpot.fulfilled, (state, action) => {
        state.jackpot = action.payload;
        state.creating = false;
        state.isCreateSuccess = true;
      })
      .addCase(updateJackpot.pending, (state, action) => {
        state.updating = true;
        state.isUpdateSuccess = false;
      })
      .addCase(updateJackpot.rejected, (state, action) => {
        state.isError = true;
        state.message = action.payload.response.data.message[0];
        state.updating = false;
      })
      .addCase(updateJackpot.fulfilled, (state, action) => {
        state.jackpot = action.payload;
        state.updating = false;
        state.isUpdateSuccess = true;
      })
      .addCase(updateJackpotStatus.pending, (state, action) => {
        state.updating = true;
        state.isUpdateStatusSuccess = false;
        const { id, data } = action.meta.arg;
        state.jackpots = state.jackpots.map((customer) =>
          customer.id === id ? { ...customer, ...data } : customer);
      })
      .addCase(updateJackpotStatus.rejected, (state, action) => {
        state.isError = true;
        state.updating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(updateJackpotStatus.fulfilled, (state, action) => {
        state.updating = false;
        state.isUpdateStatusSuccess = true;
      })

      .addCase(deleteJackpot.pending, (state, action) => {
        state.updating = true;
        state.isUpdateStatusSuccess = false;
      })
      .addCase(deleteJackpot.rejected, (state, action) => {
        state.isError = true;
        state.updating = false;
        state.message = action.payload.response.data.message[0];
      })
      .addCase(deleteJackpot.fulfilled, (state, action) => {
        state.updating = false;
        state.isUpdateStatusSuccess = true;
        // Assuming action.payload contains the id of the deleted jackpot
        const deletedId = action.meta.arg.id; // Or whatever your payload structure is    
        // Remove the jackpot from the state
        state.jackpots = state.jackpots.filter(
          (customer) => customer.id !== deletedId
        );
      })

      .addCase(getJackpot.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getJackpot.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.jackpot = action.payload;
      })
      .addCase(getJackpot.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getJackpotEntries.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getJackpotEntries.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.jackpotEntries = action.payload.jackpotEntries;
        state.jackpotEntryCount = action.payload.jackpotEntryCount;
        state.isCreateSuccess = false;
        state.isUpdateSuccess = false;
      })
      .addCase(getJackpotEntries.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getJackpotEntry.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getJackpotEntry.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.jackpotEntry = action.payload;
      })
      .addCase(getJackpotEntry.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateJackpotEntry.pending, (state, action) => {
        state.updating = true;
        state.isUpdateSuccess = false;
      })
      .addCase(updateJackpotEntry.rejected, (state, action) => {
        state.isError = true;
        state.message = action.payload.response.data.message[0];
        state.updating = false;
      })
      .addCase(updateJackpotEntry.fulfilled, (state, action) => {
        state.jackpotEntry = action.payload;
        state.updating = false;
        state.isUpdateSuccess = true;
      })
  },
});
export default jackpotSlice.reducer;
export const { initJackpot } = jackpotSlice.actions;